<template>
  <div class="member-order-records">
    <navbar show-home title="开通记录" />
    <div class="wrapper" v-show="recordsList.length">
      <list :finished="finished" @load="onLoad" finished-text="没有更多了" v-model="loading">
        <ul class="records-list">
          <li :key="index" class="records-item" v-for="(record, index) in recordsList">
            <div class="intro">
              <div class="desc">
                <p class="tit">{{record.name}}</p>
                <p class="time">{{record.create_at}}</p>
              </div>
              <div
                class="status status-handing"
                v-if="record.status === 1 || record.status === 100"
              >已受理</div>
              <div class="status status-suc" v-else-if="record.status === 9">订购成功</div>
              <div class="status status-error" v-else>订购异常</div>
            </div>
            <div
              class="tips"
              v-if="record.res && (record.status !== 1 || record.status !== 100 || record.status !== 9)"
            >{{record.res}}</div>
          </li>
        </ul>
      </list>
    </div>
    <div class="no-records" v-show="noRecords">暂无记录</div>
  </div>
</template>

<script>
import { List } from 'vant'
import Navbar from '../components/NavBar'
let flag = false
export default {
  name: 'memberOrderRecords',
  components: {
    List,
    Navbar
  },
  data () {
    return {
      recordsList: [],
      pageNum: 1,
      loading: false,
      finished: false,
      noRecords: false
    }
  },
  created () {
    this.$toast.loading('正在加载...')
    this.getRecordsList(1)
  },
  methods: {
    onLoad () {
      if (flag) {
        return
      }
      flag = true
      setTimeout(() => {
        this.getRecordsList(++this.pageNum).then(() => {
          this.loading = false
          flag = false
        })
      }, 500)
    },

    async getRecordsList (pageNum) {
      const res = await this.$axios.get(`api/member/business/${pageNum || 1}`)
      if (res.status === 200) {
        this.$toast.clear()
        const { code, msg, data } = res.data
        if (code === 0) {
          this.recordsList = [...this.recordsList, ...data]
        } else if (code === 9006) {
          this.finished = true
          if (pageNum === 1) {
            this.noRecords = true
          }
        } else {
          this.$toast(msg)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.wrapper {
  .records-list {
    .records-item {
      background-color: #fff;
      padding: 0 0.5rem;
    }
    .intro {
      .flex-between;
      height: 1.54rem;
      margin-top: 0.2rem;
      .tit {
        font-size: @fz32;
        color: @base;
      }
      .time {
        padding-top: 0.2rem;
        font-size: @fz24;
        color: @c80;
      }
      .status {
        width: 1.54rem;
        height: 0.58rem;
        font-size: @fz24;
        border-radius: 30px;
        background-color: #ccc;
        .flex-center;
      }
      .status-suc {
        background-color: #d5fce6;
        color: #2e8c57;
      }
      .status-handing {
        background-color: #d2f1ff;
        color: #4a90e2;
      }
      .status-error {
        color: #f56718;
        background-color: #ffe7cf;
      }
    }
    .tips {
      text-align: right;
      font-size: @fz24;
      color: #ff8477;
      padding-bottom: 0.2rem;
    }
  }
}
.no-records {
  padding-top: 2rem;
  text-align: center;
  font-size: @fz32;
}
</style>
